<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section"><b>Agentes</b></h2>
        </span>
        <span class="pull-right pt-1 pb-4">
          <button mat-raised-button type="button" class="btn btn-manax p-2 mr-1"
            (click)="openNewAgentModal()"><!--(click)="openNewClientModal()" -->
            <i class="material-icons">add</i>&nbsp;<span class="d-none d-sm-inline">Nuevo Agente</span>
          </button>
          <button mat-raised-button type="button" class="btn btn-outline-manax p-2 mr-1"
            (click)="openGenericExternalRequestModal()"><!--(click)="openNewClientModal()" -->
            <i class="material-icons">link</i>&nbsp;<span class="d-none d-sm-inline">Link Público de Solicitudes</span>
          </button>
        </span>
        <br><br>
        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortAgents($event)" stickyHeader
          stickyFooter>

          <thead class="text-manax pb-1">
            <tr>

              <!-- PC -->
              <th class="d-none d-md-table-cell p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                mat-sort-header="clientType">
                Nombre<br>
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                mat-sort-header="firstname">
                Telefono<br>
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                mat-sort-header="lastname">
                Emails<br>
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                mat-sort-header="nit">
                PIN Actual<br>
              </th>

              <!-- <th class="d-none d-md-table-cell align-top" width="1%"
                style="height: 65px; position: relative; max-width: 1000px;" mat-sort-header="isDeleted">
                Estado<br>
                <select class="filter small" [(ngModel)]="filter.filters.isDeleted" (ngModelChange)="lazySearch()"
                  (click)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 27px; left: 0px;">
                  <option [ngValue]="false"> activo </option> //isDeleted: false 
                  <option [ngValue]="true"> inactivo </option> //isDeleted: true 
                  <option [ngValue]="undefined"> todos </option>
                </select>
              </th> -->

              <!-- Mobile -->

              <!-- PC -->
              <th class="d-none d-md-table-cell td-actions text-right p-0">
                <!-- <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>
                </mat-menu> -->
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let agent of agents" [class.text-danger]="agent.isDeleted" class='cursor-pointer'
              (click)="openAgentModal(agent, true)">

              <!-- All -->
              <td class="d-none d-md-table-cell p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(agent._id)"
                      [checked]="selection.all || selection[agent._id || '']">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{agent.name}}</td>
              <td class="d-none d-md-table-cell">{{agent?.phone}}</td>
              <td class="d-none d-md-table-cell">{{agent?.email}}</td>
              <td class="d-none d-md-table-cell">{{agent?.pin}}</td>
              <!-- <td class="d-none d-md-table-cell">
                <span *ngIf="!agent.isDeleted">activo</span>
                <span *ngIf="agent.isDeleted">inactivo</span>
              </td> -->

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          {{agent.name}}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3" *ngIf="agent?.phone">
                        Telefono: {{agent?.phone}}
                      </div>
                      <div class="row pr-3" *ngIf="agent?.email">
                        Email: {{agent?.email}}
                      </div>
                      <div class="row pr-3" *ngIf="agent?.pin">
                        PIN: {{agent?.pin}}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openAgentModal(agent)">
                    <span>Modificar</span>
                  </button>
                  <button mat-menu-item (click)="openExternalRequestModal(agent)">
                    <span>Link para Solicitudes</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteAgentConfirm(agent, true)" *ngIf="isDev">
                    <span>Hard Delete</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteAgentConfirm(agent)" *ngIf="!agent.isDeleted">
                    <span>Eliminar</span>
                  </button>
                  <button mat-menu-item (click)="openRestoreAgentConfirm(agent)" *ngIf="agent.isDeleted">
                    <span>Restaurar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All  -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax" *ngIf="!loading">
            <tr>
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ agents.length }} Agentes</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

  </div>
</div>